import type { CwyTransferRequest } from '../services/walletService';

function requestTypeLabel(requestType?: string): string {
  if (requestType === 'treasury_deposit') return 'Vault deposit';
  return 'CWY request';
}

export function toastForVaultDepositStatus(
  deposit: CwyTransferRequest,
  amount: number,
  handlers: {
    showSuccess: (title: string, message?: string) => void;
    showWarning: (title: string, message?: string) => void;
    showError: (title: string, message?: string) => void;
  }
): void {
  const amountLabel = `${amount} CWY`;

  switch (deposit.status) {
    case 'completed':
      handlers.showSuccess(
        'Vault deposit completed',
        `${amountLabel} deposited to the treasury.`
      );
      break;
    case 'pending':
    case 'processing':
      handlers.showWarning(
        'Vault deposit pending',
        `${amountLabel} is being confirmed on Solana.`
      );
      break;
    case 'rejected':
      handlers.showError(
        'Vault deposit rejected',
        deposit.rejection_reason || 'Your deposit was declined.'
      );
      break;
    case 'failed':
      handlers.showError(
        'Vault deposit failed',
        deposit.tx_error || 'The on-chain transfer could not be completed.'
      );
      break;
    default:
      break;
  }
}

export function toastForTransferStatusChange(
  req: CwyTransferRequest,
  prevStatus: string | undefined,
  handlers: {
    showSuccess: (title: string, message?: string) => void;
    showWarning: (title: string, message?: string) => void;
    showError: (title: string, message?: string) => void;
  }
): void {
  const label = requestTypeLabel(req.request_type);

  if (req.status === 'pending' || req.status === 'processing') {
    if (prevStatus !== 'pending' && prevStatus !== 'processing') {
      handlers.showWarning(
        `${label} pending`,
        req.request_type === 'treasury_deposit'
          ? `${req.amount_cwy} CWY is being confirmed.`
          : `${req.amount_cwy} CWY is awaiting admin review.`
      );
    }
    return;
  }

  if (req.status === 'rejected') {
    handlers.showError(
      `${label} rejected`,
      req.rejection_reason || 'Your request was declined. Try again or contact support.'
    );
    return;
  }

  if (req.status === 'failed') {
    handlers.showError(
      `${label} failed`,
      req.tx_error || 'The on-chain transfer could not be completed.'
    );
    return;
  }

  if (req.status === 'completed') {
    handlers.showSuccess(
      `${label} completed`,
      `${req.amount_cwy} CWY · ${
        req.request_type === 'treasury_deposit'
          ? 'Deposited to vault'
          : 'Tokens sent to your wallet'
      }`
    );
  }
}
